import { useEffect } from "react";
import { builder, BuilderComponent } from "@builder.io/react";
import type { InferGetStaticPropsType } from "next";
import Link from "next/link";

import { analytics } from "@flare/analytics";
import { Heading, Icon, Text } from "@flare/ui/components";

import { sectionModel } from "@/builder/model-names";
import { BiEventsNames } from "@/services/analytics/bi-event-names";

import "@/components/Builder/index";

export default function NotFoundPage({
  navbar,
}: Partial<InferGetStaticPropsType<typeof getStaticProps>>) {
  useEffect(() => {
    analytics.track(BiEventsNames.WebPageError, {
      error_type: "404",
    });
  }, []);

  return (
    <div className="min-h-screen bg-surface">
      <BuilderComponent model="symbol" content={navbar} />
      <section className="m-auto max-w-[1440px] px-sp-6 py-sp-9 sm:px-sp-9 sm:py-[104px]">
        <Heading variant="h1" as="h2" textColor="danger-highlight">
          404.
        </Heading>
        <Heading variant="h1" as="h2" className="mt-sp-2 max-w-[864px]">
          We can’t find the page you’re looking for but we can help you find the
          right attorney.
        </Heading>
        <Text variant="body2-highlight" className="mb-sp-8 mt-sp-9 uppercase">
          Discover your path forward:
        </Text>
        <Link href="/family">
          <Text
            variant="body1-highlight"
            className="my-sp-5 flex items-center gap-sp-2"
          >
            Family law <Icon name="arrow-right" />
          </Text>
        </Link>
        <Link href="/immigration">
          <Text
            variant="body1-highlight"
            className="my-sp-5 flex items-center gap-sp-2"
          >
            Immigration law <Icon name="arrow-right" />
          </Text>
        </Link>
        <Link href="/pricing">
          <Text
            variant="body1-highlight"
            className="my-sp-5 flex items-center gap-sp-2"
          >
            Pricing <Icon name="arrow-right" />
          </Text>
        </Link>
        <Link href="/reviews">
          <Text
            variant="body1-highlight"
            className="my-sp-5 flex items-center gap-sp-2"
          >
            Reviews <Icon name="arrow-right" />
          </Text>
        </Link>
      </section>
    </div>
  );
}

type WebsiteNavbarBuilder = { [key: string]: unknown };

export async function getStaticProps() {
  const navbar: WebsiteNavbarBuilder = await builder.get(sectionModel.symbol, {
    url: "/new-website-navigation-bar",
  });

  return {
    props: {
      navbar,
    },
  };
}
